import { PidNode } from './PidNode'
import { cx, TagLabel, type PidBaseProps } from './shared'

export interface ThermometerProps extends PidBaseProps {
  value: number
  unit?: string
  min?: number
  max?: number
  layout?: 'port' | 'stack'
}

const GLYPH_H = 72

export function Thermometer({
  value,
  unit = '°C',
  min = 0,
  max = 150,
  layout = 'port',
  tag,
  className,
  style,
  title
}: ThermometerProps) {
  const frac = Math.max(0, Math.min(1, (value - min) / (max - min || 1)))
  const stemTop = 8
  const stemBottom = 52
  const stemH = stemBottom - stemTop
  const fillH = stemH * frac
  const fillY = stemBottom - fillH

  const glyph = (
    <svg width={40} height={GLYPH_H} viewBox="0 0 40 72" aria-hidden>
      <rect
        className="pid-fill pid-stroke"
        x={15}
        y={6}
        width={10}
        height={50}
        rx={5}
        strokeWidth={1.5}
      />
      <rect className="pid-thermo-fill" x={16.5} y={fillY} width={7} height={fillH} rx={3.5} />
      <circle className="pid-thermo-fill pid-stroke" cx={20} cy={60} r={10} strokeWidth={1.5} />
      <circle className="pid-thermo-fill" cx={20} cy={60} r={6.5} />
      {[0.25, 0.5, 0.75].map((t) => (
        <line
          key={t}
          className="pid-muted-stroke"
          x1={25}
          y1={stemTop + stemH * (1 - t)}
          x2={30}
          y2={stemTop + stemH * (1 - t)}
          strokeWidth={1}
        />
      ))}
    </svg>
  )

  return (
    <div style={style} title={title ?? tag} className={cx(className)}>
      <PidNode glyph={glyph} glyphHeight={GLYPH_H} mode={layout}>
        <div className="pid-readout">
          <span className="pid-readout-value">{value.toFixed(1)}</span>
          <span className="pid-readout-unit">{unit}</span>
        </div>
        <TagLabel>{tag}</TagLabel>
      </PidNode>
    </div>
  )
}
